// extracted by mini-css-extract-plugin
module.exports = {"error-page":"styles_error-page__2Efso","errorPage":"styles_error-page__2Efso"};